import React from "react"
import { useState, useEffect } from 'react'
import DodonesShow from "app/dodones/Show.jsx"

const DaysCurrent = () => {
  return <DodonesShow dodoneId="today"/>;
};

export default DaysCurrent;
